(function () {
  function initModalNav(modal) {
    const prevBtn = modal.querySelector('.dd-modal-nav--prev');
    const nextBtn = modal.querySelector('.dd-modal-nav--next');
    const status  = modal.querySelector('.dd-modal-status');

    if (!prevBtn || !nextBtn) return;

    // Prevent nav button clicks from triggering the modal's "click outside to close" handler
    [prevBtn, nextBtn].forEach(btn => {
      btn.addEventListener('pointerup', e => e.stopPropagation());
    });

    function getSlides() {
      return Array.from(modal.querySelectorAll('[data-media-id]'));
    }

    function activeIndex(slides) {
      return slides.findIndex(s => s.classList.contains('active'));
    }

    function goTo(index) {
      const slides = getSlides();
      if (slides.length < 2) return;
      slides.forEach((s, i) => s.classList.toggle('active', i === index));
      updateNav(slides, index);
      if (status) {
        status.textContent = 'Image ' + (index + 1) + ' of ' + slides.length;
      }
    }

    function updateNav(slides, index) {
      const multi = slides.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= slides.length - 1;
    }

    prevBtn.addEventListener('click', () => {
      const slides = getSlides();
      const i = activeIndex(slides);
      if (i > 0) goTo(i - 1);
    });

    nextBtn.addEventListener('click', () => {
      const slides = getSlides();
      const i = activeIndex(slides);
      if (i < slides.length - 1) goTo(i + 1);
    });

    // Arrow key navigation while modal is open
    modal.addEventListener('keydown', e => {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); prevBtn.click(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); nextBtn.click(); }
    });

    // Sync nav state whenever the modal opens
    new MutationObserver(() => {
      if (modal.hasAttribute('open')) {
        const slides = getSlides();
        const i = activeIndex(slides);
        updateNav(slides, i >= 0 ? i : 0);
        if (status && slides.length > 1) {
          status.textContent = 'Image ' + (i + 1) + ' of ' + slides.length;
        }
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  // Init after DOM is ready; product-modal elements are appended to body on connectedCallback
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      document.querySelectorAll('product-modal').forEach(initModalNav)
    );
  } else {
    document.querySelectorAll('product-modal').forEach(initModalNav);
  }
})();
